import request from '@/utils/request';
import type {
  CreateSpecificationParams,
  CreateSpecificationValueParams,
  Specification,
  SpecificationQueryParams,
  UpdateSpecificationParams,
  UpdateSpecificationValueParams,
} from '../types/specification';
import type {PaginatedResponse} from '@/types/common';

export const specificationService = {
  // 获取规格列表
  getSpecificationList: (params: SpecificationQueryParams) => {
    return request.get<PaginatedResponse<Specification>>('/api/admin/product/specification', { params });
  },

  // 创建规格
  createSpecification: (data: CreateSpecificationParams) => {
    return request.post<Specification>('/api/admin/product/specification', data);
  },

  // 更新规格
  updateSpecification: (id:number,data: UpdateSpecificationParams) => {
    return request.put<Specification>(`/api/admin/product/specification/${id}`, data);
  },

  // 删除规格
  deleteSpecification: (id: number) => {
    return request.delete(`/api/admin/product/specification/${id}`);
  },

  // 获取规格详情
  getSpecificationDetail: (id: number) => {
    return request.get<Specification>(`/api/admin/product/specification/${id}`);
  },

  // 获取分类下的规格列表
  getSpecificationsByCategory: (categoryId: number, merchantId?: number) => {
    return request.get<Specification[]>(`/api/admin/product/specification/category/${categoryId}`, {
      params: merchantId != null ? { merchantId } : {},
    });
  },

  // 创建规格值
  createSpecificationValue: (specificationId: number, data: CreateSpecificationValueParams) => {
    return request.post<Specification>(`/api/admin/product/specification/${specificationId}/values`, data);
  },

  // 更新规格值
  updateSpecificationValue: (specificationId: number, valueId: number, data: UpdateSpecificationValueParams) => {
    return request.put<Specification>(`/api/admin/product/specification/${specificationId}/values/${valueId}`, data);
  },

  // 删除规格值
  deleteSpecificationValue: (specificationId: number, valueId: number) => {
    return request.delete<Specification>(`/api/admin/product/specification/${specificationId}/values/${valueId}`);
  },

  // 更新规格状态
  updateSpecificationStatus: (id: number, enabled: boolean) => {
    return request.put(`/api/admin/product/specification/${id}/status`, null, { params: { enabled } });
  },

  // 更新规格值状态
  updateSpecificationValueStatus: (specificationId: number, valueId: number, enabled: boolean) => {
    return request.put(
      `/api/admin/product/specification/${specificationId}/values/${valueId}/status`,
      null,
      { params: { enabled } }
    );
  },
};
